import { Injectable } from '@angular/core';
import { Service } from 'src/app/core/jsonapi/service';
import { MailAccount } from '../_types/mail-account';
import { Observable } from 'rxjs';
import { MailMessage } from '../_types/mail-message';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root'
})
export class MailAccountsService extends Service<MailAccount> {
  public override type = 'mailAccounts';
  public override url = 'communications/mailAccounts';
      
  public getMailboxUrl(mailAccountId: string): string {
    return `${environment.api_gw}${this.url}/${mailAccountId}/mailbox/login`;
  }
  
}
